import { render, staticRenderFns } from "./FilesInput.vue?vue&type=template&id=4b3826d0"
import script from "./FilesInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports